const QuestionsList=[
  {
      question: "What temperature does water boil at ?",
   answersList:[  
     { answer:"50 degrees Celcius",isCorrect:false},
     { answer:"25 degrees Celcius",isCorrect:false},
     { answer:"100 degrees Celcius",isCorrect:true},
     { answer:"150 degrees Celcius",isCorrect:false},
      
],
  },




  {
      question: "What did the crocodile swallow in Peter Pan ?",
   answersList:[  
     { answer:"A Book",isCorrect:false},
     { answer:"A Computer",isCorrect:false},
     { answer:"A pair of shoes",isCorrect:false},
     { answer:"Alarm Clock",isCorrect:true},
      
],
  },


  {
      question: "Which is the only mammal that can’t jump ?",
   answersList:[  
     { answer:"Dog",isCorrect:false},
     { answer:"Elephant",isCorrect:true},
     { answer:"Goat",isCorrect:false},
     { answer:"Lion",isCorrect:false},
      
],
  },



  {
      question: "Who lived at 221B, Baker Street, London ?",
   answersList:[  
     { answer:"Tony Stark",isCorrect:false},
     { answer:"Morgan Freeman",isCorrect:false},
     { answer:"Sherlock Holmes",isCorrect:true},
     { answer:"Samuel L. Jackson",isCorrect:false},
      
],
  },



  {
      question: "What colour is a panda ?",
   answersList:[  
     { answer:"Green and Yellow",isCorrect:false},
     { answer:"Blue and Red",isCorrect:false},
     { answer:"Green and White",isCorrect:false},
     { answer:"Black and White",isCorrect:true},
      
],
  },



  {
      question: "Where is the smallest bone in the human body ?",
   answersList:[  
     { answer:"The Chest",isCorrect:false},
     { answer:"The Ear",isCorrect:true},
     { answer:"The Legs",isCorrect:false},
     { answer:"The Hands",isCorrect:false},
      
],
  },



  {
  



  
      question: "What takes place in Hong Kong's Happy Valley ?",
   answersList:[  
     { answer:"Chicken Wrestling",isCorrect:false},
     { answer:"Horse racing",isCorrect:true},
     { answer:"Street Racing",isCorrect:false},
     { answer:"Arm Wrestling",isCorrect:false},
      
],
  },




  {
      question: "Who painted the Mona Lisa ?",
   answersList:[  
     { answer:"Alexander Graham Bell",isCorrect:false},
     { answer:"Sir Isaac Newton",isCorrect:false},
     { answer:"Leonardo Da Vinci",isCorrect:true},
     { answer:"Albert Einstein",isCorrect:false},
      
],
  },








 


  {
      question: "How many squares are there on a chess board ?",
   answersList:[  
     { answer:"128",isCorrect:false},
     { answer:"64",isCorrect:true},
     { answer:"32",isCorrect:false},
     { answer:"256",isCorrect:false},
      
],
  },








  {
      question: "What are the first three words of the bible ?",
   answersList:[  
     { answer:"be with everyone",isCorrect:false},
     { answer:"Again Jesus asked",isCorrect:false},
     { answer:"In the beginning",isCorrect:true},
     { answer:"At that time",isCorrect:false},
      
],
  },




{
      question: "What is full form of WWW ?",
   answersList:[  
     { answer:"World Width Web",isCorrect:false},
     { answer:"World War Won",isCorrect:false},
     { answer:"World Wide Web",isCorrect:true},
     { answer:"World Web Wide",isCorrect:false},
      
],
  },


{
      question: "What is the capital of USA ?",
   answersList:[  
     { answer:"New York",isCorrect:false},
     { answer:"Washington DC",isCorrect:true},
     { answer:"Chicago",isCorrect:false},
     { answer:"Florida",isCorrect:false},
      
],
  },


{
      question: "What is the highest peak in the world ?",
   answersList:[  
     { answer:"Mount Everest",isCorrect:true},
     { answer:"Mount K2",isCorrect:false},
     { answer:"Annapurna",isCorrect:false},
     { answer:"Makalu",isCorrect:false},
      
],
  },




{
      question: "who is the highest earing Youtuber in 2020 ?",
   answersList:[  
     { answer:"Mr.Beast",isCorrect:false},
     { answer:"David Dobrik",isCorrect:false},
     { answer:"Dude Perfect",isCorrect:false},
     { answer:"Ryan Kaji",isCorrect:true},
      
],
  },




{
      question: "Who maintains React ?",
   answersList:[  
     { answer:"Google",isCorrect:false},
     { answer:"Amazon",isCorrect:false},
     { answer:"Facebook",isCorrect:true},
     { answer:"Apple",isCorrect:false},
      
],
  },


];
export default QuestionsList;




























